import State from 'store/State';
import { selectWidgetInstancesState } from 'widgets/store/selectors';
import { WidgetType } from 'widgets/WidgetType';

export const selectPredictedVolumeCapsulesState = (state: State) =>
    selectWidgetInstancesState(state)[WidgetType.PREDICTED_VOLUME_CAPSULE];

export const selectPredictedVolumeCapsuleState = (
    state: State,
    widgetKey: string
) => selectPredictedVolumeCapsulesState(state)[widgetKey];

export const selectPredictedCloseVolumeCapsulesState = (state: State) =>
    selectWidgetInstancesState(state)[
        WidgetType.PREDICTED_CLOSE_VOLUME_CAPSULE
    ];

export const selectPredictedCloseVolumeCapsuleState = (
    state: State,
    widgetKey: string
) => selectPredictedCloseVolumeCapsulesState(state)[widgetKey];
